import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class ChapterHistoryApi<ChapterHistory> extends BaseAPI {
  public getChapterHistoriesByChapterId: (id: string) => Promise<ChapterHistory[]> = async (id: string) => {
    return (await BaseAPI.axios.get(`${baseUrl}/chapterHistory/${id}`)).data.output;
  };

  public save: (chapterHistory: ChapterHistory) => Promise<ChapterHistory> = async (chapterHistory: ChapterHistory) => {
    return (await BaseAPI.axios.post(`${baseUrl}/chapterHistory/`, chapterHistory)).data.output;
  }

  public delete: (id: string) => Promise<any> = async (id: string) => {
    return (await BaseAPI.axios.delete(`${baseUrl}/chapterHistory/${id}`)).data.output;
  }
}

export const chapterHistoryApi = new ChapterHistoryApi();
